<script>
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import CardJadwalAsesmen from "./card-jadwal-asesmen.vue";
import axios from "axios";
import Swal from "sweetalert2";
import { getStoredUserId } from "@/helpers/sessionHelper";

export default {
  components: {
    Datatable,
    Pagination,
    CardJadwalAsesmen,
  },
  props: {
    // "kkj" | "pembinaan_grade"
    tipeAsesmen: {
      type: String,
      required: true,
    },
  },
  data() {
    let sortOrders = []; // select sortOrder
    // definisi kolom yang dipakai
    let columns = [
      { width: "50px", label: "No", name: "-" },
      { width: "auto", label: "Kode Tes", name: "kode_tes" },
      { width: "auto", label: "Pelaksanaan", name: "-" },
      { width: "auto", label: "Keterangan", name: "keterangan" },
      { width: "150px", label: "Tanggal Mulai", name: "tanggal_mulai" },
      { width: "150px", label: "Tanggal Selesai", name: "tanggal_selesai" },
      // { width: "100px", label: "Status", name: "-" },
      { width: "150px", label: "Aksi", name: "-" },
    ];
    // cek sorting
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      isWrite: localStorage.getItem("isWrite"),
      isRead: localStorage.getItem("isRead"),
      namePathUrl: this.$route.name,
      sessionRoleId: localStorage.session_role_active_id,
      sessionUserId: getStoredUserId() || localStorage.session_user_id || "",
      // sembunyikan datatable sementara, tampilan utama pakai card
      showDatatable: false,

      tableData: {
        columns: columns,
        sortKey: "kode_tes",
        sortOrders: sortOrders,
        loading: true,
        data: [],
        filter: {
          page: 1,
          per_page: 10,
          // 1 = Belum Mengerjakan, 2 = Sedang Mengerjakan
          status_pengerjaan: [1, 2],
          tipe_asesmen: this.tipeAsesmen,
        },
        pagination: {
          lastPage: "",
          currentPage: "",
          total: "",
          lastPageUrl: "",
          nextPageUrl: "",
          prevPageUrl: "",
          from: "",
          to: "",
          links: "",
        },
      },
    };
  },
  async mounted() {
    await this.getDataTable();
  },
  methods: {
    getEffectiveUserId() {
      const id =
        getStoredUserId() ||
        this.sessionUserId ||
        localStorage.getItem("session_user_id");
      if (id && (!this.sessionUserId || this.sessionUserId !== String(id))) {
        this.sessionUserId = String(id);
      }
      return id ? String(id) : null;
    },
    getDataTable(resetPage = true) {
      let self = this;
      const userId = this.getEffectiveUserId();
      self.tableData.loading = true;
      if (resetPage) {
        self.tableData.filter.page = 1;
      }

      // TODO: sesuaikan endpoint setelah BE final (placeholder: pegawai/jadwal-asesmen)
      var config = {
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION + "pegawai/jadwal-asesmen",
        params: {
          id_pegawai: userId,
          ...self.tableData.filter,
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config)
        .then((response) => {
          let response_data = response.data;
          if (response_data.meta.code == 200) {
            let response_data_fix = response_data.data;
            self.tableData.data = response_data_fix.data;
            self.configPagination(response_data_fix);
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data.meta.message,
            });
          }
          self.tableData.loading = false;
        })
        .catch((errors) => {
          console.log(errors);
          self.tableData.loading = false;
        });
    },
    configPagination(data) {
      this.tableData.pagination.lastPage = data.last_page;
      this.tableData.pagination.currentPage = data.current_page;
      this.tableData.pagination.total = data.total;
      this.tableData.pagination.lastPageUrl = data.last_page_url;
      this.tableData.pagination.nextPageUrl = data.next_page_url;
      this.tableData.pagination.prevPageUrl = data.prev_page_url;
      this.tableData.pagination.from = data.from;
      this.tableData.pagination.to = data.to;
      this.tableData.pagination.links = data.links;
    },
    toPage(url) {
      let link = new URLSearchParams(url.split("?")[1] || "");
      this.tableData.filter.page = link.get("page");
      this.getDataTable(false);
    },
    sortBy(key) {
      let self = this;
      self.tableData.sortKey = key;
      self.tableData.sortOrders[key] = self.tableData.sortOrders[key] * -1;
      self.getDataTable();
    },
    // TODO: sesuaikan endpoint setelah BE final (placeholder: pegawai/jadwal-asesmen/generate-sso)
    async generateSso(row_data) {
      return axios
        .post(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "pegawai/jadwal-asesmen/generate-sso",
          {
            token_jadwal: row_data.token_jadwal,
            nip: localStorage.session_username,
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token,
            },
          }
        )
        .then((response) => {
          let response_data = response.data;
          if (response_data.meta.code == 200) {
            return response_data.data;
          }
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response_data.meta.message,
          });
          return false;
        })
        .catch((errors) => {
          console.log(errors);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            html: "Gagal memulai asesmen, silahkan coba lagi.<br>" + errors.response.data.data,
          });
          return false;
        });
    },
    mulai(row_data) {
      let self = this;
      Swal.fire({
        icon: "question",
        title: "Perhatian",
        text: "Apakah anda yakin ingin memulai asesmen ini?",
        showCancelButton: true,
        confirmButtonText: "Ya",
        cancelButtonText: "Tidak",
      }).then(async (result) => {
        if (!result.isConfirmed) {
          return;
        }

        Swal.fire({
          title: "Memproses...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        const ssoToken = await self.generateSso(row_data);
        if (!ssoToken) {
          return;
        }

        Swal.close();
        let timerInterval;
        Swal.fire({
          icon: "success",
          title: "Berhasil",
          text: "Anda akan diarahkan ke halaman dashboard segera",
          timer: 2000,
          timerProgressBar: true,
          showCancelButton: false,
          showConfirmButton: false,
          willClose: () => {
            clearInterval(timerInterval);
          },
        }).then((result2) => {
          if (result2.dismiss === Swal.DismissReason.timer) {
            self.$router.push({
              name: "dashboard-assesmen-hc",
              query: {
                sso: ssoToken,
              },
            });
          }
        });
      });
    },
  },
};
</script>
<template>
  <div class="card">
    <div class="card-body">
      <div class="mym-jadwal-grid mb-4">
        <div v-if="tableData.loading" class="mym-jadwal-loading">
          <i class="fas fa-spinner fa-spin"></i> Loading...
        </div>
        <div
          v-else-if="!tableData.data || tableData.data.length === 0"
          class="mym-jadwal-empty"
        >
          Data Tidak Tersedia
        </div>
        <CardJadwalAsesmen
          v-else
          v-for="(row_data, key_data) in tableData.data"
          :key="row_data.idjadwal_peserta"
          :rowData="row_data"
          :nomor="(tableData.pagination.from || 1) + key_data"
          @mulai="mulai"
        />
      </div>

      <div v-if="showDatatable" class="row">
        <datatable
          :columns="tableData.columns"
          :sortKey="tableData.sortKey"
          :sortOrders="tableData.sortOrders"
          @sort="sortBy"
        >
          <tbody>
            <tr v-if="tableData.loading">
              <td colspan="99" class="text-center">
                <i class="fas fa-spinner fa-spin"></i> Loading...
              </td>
            </tr>
            <tr
              v-else-if="!tableData.data || tableData.data.length === 0"
              class="text-center"
            >
              <td class="text-center" colspan="99">Data Tidak Tersedia</td>
            </tr>
            <tr
              v-else
              v-for="(row_data, key_data) in tableData.data"
              :key="row_data.idjadwal_peserta"
            >
              <td class="text-center">
                {{ (tableData.pagination.from || 1) + key_data }}
              </td>
              <td class="text-center">{{ row_data?.kode_tes || "-" }}</td>
              <td class="text-center">{{ row_data?.pelaksanaan || "-" }}</td>
              <td class="text-center">{{ row_data?.keterangan || "-" }}</td>
              <td class="text-center">{{ row_data?.tanggal_mulai || "-" }}</td>
              <td class="text-center">{{ row_data?.tanggal_selesai || "-" }}</td>
              <td class="text-center">
                <button
                  type="button"
                  class="btn btn-primary btn-sm"
                  @click="mulai(row_data)"
                >
                  <i class="fa fa-play"></i> Mulai
                </button>
              </td>
            </tr>
          </tbody>
        </datatable>
      </div>
      <pagination
        :pagination="tableData.pagination"
        @to-page="toPage"
      ></pagination>
    </div>
  </div>
</template>
